import api from '@/services/api';
import { PaginatedResponse } from '@/types/common';
import { Source, SourceHistoryItem, SourcesQueryParams } from '@/types/sources';

export const sourcesService = {
  async getAll(params?: SourcesQueryParams): Promise<PaginatedResponse<Source>> {
    const queryParams = new URLSearchParams();

    
    const offset = params?.offset !== undefined ? params.offset : 0;
    const limit = params?.limit !== undefined ? params.limit : 10;
    
    queryParams.append('offset', offset.toString());
    queryParams.append('limit', limit.toString());
    
    if (params?.q) {
      queryParams.append('q', params.q);
    }

    const url = `/sources?${queryParams.toString()}`;
    const response = await api.get<PaginatedResponse<Source>>(url);
    return response.data;
  },

  async getById(id: string): Promise<Source> {
    const response = await api.get<Source>(`/sources/${id}`);
    return response.data;
  },

  async syncSources(): Promise<void> {
    await api.post('/sources/sync');
  },

  async getHistory(id: string, params?: { offset?: number; limit?: number }): Promise<PaginatedResponse<SourceHistoryItem>> {
    const queryParams = new URLSearchParams();
    
    
    const offset = params?.offset !== undefined ? params.offset : 0;
    const limit = params?.limit !== undefined ? params.limit : 10;
    
    queryParams.append('offset', offset.toString());
    queryParams.append('limit', limit.toString());
    
    const url = `/sources/${id}/history?${queryParams.toString()}`;
    const response = await api.get<PaginatedResponse<SourceHistoryItem>>(url);
    return response.data;
  },
}; 